import {useState, ReactNode, useMemo} from "react";
// @ts-ignore
import {APIContext} from "../Globals.tsx";
// @ts-ignore
import {MyLoadingSpinner} from "./MyLoadingSpinner.tsx";
// @ts-ignore
import {Modal} from "../Modal.tsx";
// @ts-ignore
import {deleteBackendAsync, fetchBackendAsync, postBackendAsync} from "./APIfunctions.tsx";
// @ts-ignore
import {loadFromStorage, clearStorage, storeInStorage, deleteFromStorage} from './LocalStorage.tsx';
import {NewsDTO} from "../model/NewsDTO";
import {LocationDTO} from "../model/LocationDTO";
import {CourseTypeDTO} from "../model/CourseTypeDTO";
import {TagsDTO} from "../model/TagsDTO";
import {BoxDTO} from "../model/BoxDTO";
import {ContractDTO} from "../model/ContractDTO";
import {PersonDTO} from "../model/PersonDTO";
import {EmailStringDTO} from "../model/EmailStringDTO";
import {createAutoFills} from "../../script/parseComponent"
import {CrossfitComWorkoutDTO} from "../model/CrossfitComWorkoutDTO";


type Props = {
  children: ReactNode; setToken: (data: string | null) => void
};

type ErrorType = {
  header: string; text: string; callback: null | ((any?) => void); error?: string
};

export function setError(text){
  let element = document.getElementById("error-message");
  if(element){
    element.innerHTML = text
  }
}

export function checkUserData(user){
  let tmp = JSON.parse(JSON.stringify(user));
  if(!user.birthday.match("\\d+-\\d+-\\d+")){
    console.log("invalid birthdate");
    setError("Geburtstag ungültig");
    return null;
  }
  tmp.birthday = user.birthday;
  if(!user.email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )){
    console.log("invalid email");
    setError("E-Mail ungültig");
    return null;
  }
  if(!tmp.firstname || !tmp.lastname){
    console.log("need firstname and lastname");
    setError("Vor- oder Nachname ungültig");
    return null;
  }
  if(tmp.contract){
    if(tmp.contract.repeat && !user.contract.startDate?.match("\\d+-\\d+-\\d+")){
      console.log("invalid date contract start");
      setError("Startdatum ungültig");
      return null;
    }
    tmp.contract.startDate = user.contract.startDate;
    if(tmp.contract.repeat && !user.contract.endDate?.match("\\d+-\\d+-\\d+")){
      console.log("invalid date contract end");
      setError("Enddatum ungültig");
      return null;
    }
    tmp.contract.endDate = user.contract.endDate;
    if(!tmp.contract.repeat){
      tmp.contract = null;
    }
  }
  if(!tmp.sex){
    console.log("invalid sex");
    setError("Geschlecht ungültig");
    return null;
  }
  return tmp;
}

export function useDeleteConfirmation() {
  const [warning, setWarning] = useState<any>(null);
  const [resolvePromise, setResolvePromise] = useState<((value: boolean) => void) | null>(null);

  function confirmDelete(text :string): Promise<boolean> {
    return new Promise((resolve) => {
      setResolvePromise(() => resolve); // Store resolve function
      setWarning({
        text: text,
        header: "Bestätigen",
      });
    });
  }

  function handleConfirm(confirmed: boolean) {
    if (resolvePromise) resolvePromise(confirmed); // Resolve the promise
    setWarning(null); // Close the warning modal
  }

  function WarningModal() {
    if (!warning) return null;
    return (<Modal
            header={warning.header}
            children={warning.text}
            buttonP={"Ja"}
            buttonS={"Nein"}
            actionP={() => {
              handleConfirm(true)
            }}
            actionS={() => {
              handleConfirm(false)
            }}
            valid={true}
        />);
  }

  return { confirmDelete, WarningModal };
}

export default function API({children, setToken}: Props){
  const defaultError: ErrorType = {
    header: "Ein Fehler ist aufgetreten",
    text: "Leider trat bei der Verbindung ein Fehler auf, um details zu sehen klicke den untersten Button.",
    callback: null
  };
  const [error, setError] = useState<ErrorType | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const { confirmDelete, WarningModal } = useDeleteConfirmation();

  const apiContext = useMemo(() => ({
    setLoading: setIsLoading,
    setUpdating: setIsUpdating,
    getEgo: getEgo,
    logout: logout,
    login: login,
    signInPerson: signInPerson,
    signOutPerson: signOutPerson,
    getTags: getTags,
    fetchCoaches: fetchCoaches,
    fetchLocations: fetchLocations,
    pushLocation: pushLocation,
    fetchCourseTypes: fetchCourseTypes,
    pushCourseType: pushCourseType,
    addTag: addTag,
    addUser: addUser,
    saveTags: saveTags,
    searchComponents: searchComponents,
    searchComponentsByTag: searchComponentsByTag,
    deleteComponent: deleteComponent,
    fetchNews: fetchNews,
    pushNews: pushNews,
    deleteNews: deleteNews,
    getWeek: getWeek,
    fetchPrograms: getPrograms,
    saveBox: saveBox,
    getUsers: getUsers,
    deleteUser: deleteUser,
    getProducts: getProducts,
    saveProduct: saveProduct,
    getContracts: getContracts,
    saveContract: saveContract,
    getEmailStrings: getEmailStrings,
    saveEmailString: saveEmailString,
    testEmailStrings: testEmailStrings,
    enablePersonForPayment: enablePersonForPayment,
    enableContractForPayment: enableContractForPayment,
    disableContractForPayment: disableContractForPayment,
    enableProductForPayment: enableProductForPayment,
    disableProductForPayment: disableProductForPayment,
    fetchCalendarWeek: fetchCalendarWeek,
    dropIn: dropIn,
    createLeadAndDropin: createLeadAndDropin,
    signInDropIn: signInDropIn,
    getAutoFills: getAutoFills,
    deleteCourseType: deleteCourseType,
    fetchCrossfitWorkouts: fetchCrossfitWorkouts,
    translate: translate
  }), []);

  function logout(){
    setToken(null)
    clearStorage()
  }

  async function addUser(user: PersonDTO){
    let tmp = checkUserData(user)
    if (!tmp)
      return null
    return await postBackendAsync("/users", tmp, defaultCatch(() => addUser(user)));
  }

  async function createLeadAndDropin(backend: string, user: PersonDTO, course: string){
    let tmp = checkUserData(user)
    if (!tmp)
      return null
    setIsLoading(true)
    let ans = await postBackendAsync(`${backend}/leadDropin?course=${course}`, tmp, defaultCatch(() => createLeadAndDropin(backend, user, course)));
    setIsLoading(false)
    return ans
  }

  async function signInDropIn(backend: string, paymentIntent: string, courseId: string){
    setIsLoading(true)
    let ans = await fetchBackendAsync(`${backend}/courses/signinDropin?course=`+courseId+"&paymentIntent=" + paymentIntent, defaultCatch(() => signInDropIn(backend, courseId, paymentIntent)));
    setIsLoading(false)
    return ans
  }

  function defaultCatch(callback: () => void){
    return async (e: any) => {
      let tmp = defaultError;
      tmp.text = e;
      setError({...tmp, ...{callback: callback}});
    };
  }

  async function getEgo(){
    let ego = await loadFromStorage("ego")
    if(!ego){
      ego = await fetchBackendAsync("/user", defaultCatch(() => getEgo()));
    }
    return ego
  }

  async function login(email: string, password: string){
    return await postBackendAsync("/login", {
      email: email, password: password,
    }, defaultCatch(() => login(email, password)), true);
  }

  async function getTags(){
    return await fetchBackendAsync("/getTags", defaultCatch(() => getTags()));
  }

  async function enablePersonForPayment(id: string){
    return await fetchBackendAsync("/users/enablePayment?id="+id, defaultCatch(() => enablePersonForPayment(id)));
  }

  async function enableContractForPayment(id: string){
    return await fetchBackendAsync("/contracts/enablePayment?id="+id, defaultCatch(() => enableContractForPayment(id)));
  }

  async function disableContractForPayment(id: string){
    return await fetchBackendAsync("/contracts/disablePayment?id="+id, defaultCatch(() => disableContractForPayment(id)));
  }

  async function enableProductForPayment(id: string){
    return await fetchBackendAsync("/products/enablePayment?id="+id, defaultCatch(() => enableContractForPayment(id)));
  }

  async function disableProductForPayment(id: string){
    return await fetchBackendAsync("/products/disablePayment?id="+id, defaultCatch(() => disableContractForPayment(id)));
  }

  async function getWeek(startDate?: Date){
    let today = (startDate ?? new Date()).toLocaleDateString('de-DE')
    const tomorrow = new Date(startDate ?? new Date());
    tomorrow.setDate(tomorrow.getDate() + 6);
    return await fetchBackendAsync(`/weekssingle/load?startDate=${today}&endDate=${tomorrow.toLocaleDateString('de-DE')}`, defaultCatch(() => getWeek(startDate)));
  }

  async function getPrograms(startDate: string, endDate: string, type: string, loading: boolean = false){
    if(loading)
      setIsLoading(true)
    let tmp = await fetchBackendAsync(`/programs/week?startDate=${startDate}&endDate=${endDate}&type=${encodeURIComponent(type)}`, defaultCatch(() => getPrograms(startDate, endDate, type)));
    if(loading)
      setIsLoading(false)
    return tmp;
  }

  async function getUsers(){
    return await fetchBackendAsync("/users?q=", defaultCatch(() => getUsers()));
  }

  async function fetchLocations(){
    return await fetchBackendAsync("/locations", defaultCatch(() => fetchLocations()));
  }

  async function pushLocation(location: LocationDTO){
    return await postBackendAsync("/locations", location, defaultCatch(() => pushLocation(location)));
  }

  async function fetchNews(){
    return await fetchBackendAsync("/news/all", defaultCatch(() => fetchNews()));
  }

  async function pushNews(data: NewsDTO){
    return await postBackendAsync("/news", data, defaultCatch(() => pushNews(data)));
  }

  async function deleteNews(id: String){
    return await deleteBackendAsync("/news/" + id, defaultCatch(() => deleteNews(id)));
  }

  async function deleteUser(id: string) {
    const confirmed = await confirmDelete("Wirklich löschen?");
    if (!confirmed) {
      return;
    }
    return await deleteBackendAsync("/users?id=" + id, defaultCatch(() => deleteUser(id)));
  }

  async function signInPerson(course: string, person: string) {
    const confirmed = await confirmDelete("Willst du diese Person in den Kurs einchecken?");
    if (!confirmed) {
      return;
    }
    return await fetchBackendAsync("/courses/signinPerson?course="+course+"&person=" + person, defaultCatch(() => signInPerson(course, person)));
  }

  async function signOutPerson(course: string, person: string) {
    const confirmed = await confirmDelete("Willst du diese Person von den Kurs abmelden?");
    if (!confirmed) {
      return;
    }
    return await fetchBackendAsync("/courses/signoutPerson?course="+course+"&person=" + person, defaultCatch(() => signOutPerson(course, person)));
  }


  async function addTag(tag: String){
    return await postBackendAsync("/addTags", {name: tag.trim()}, defaultCatch(() => addTag(tag)));
  }

  async function saveTags(tags: TagsDTO){
    return await postBackendAsync("/saveTags", tags, defaultCatch(() => saveTags(tags)));
  }

  async function saveBox(box: BoxDTO){
    return await postBackendAsync("/boxes", box, defaultCatch(() => saveBox(box)), true);
  }

  async function getContracts(force = true){
    setIsLoading(true)
    let contracts = await loadFromStorage("contracts")
    if(force || !contracts){
      contracts = await fetchBackendAsync("/contracts", defaultCatch(() => getContracts()));
      await storeInStorage("contracts", contracts)
    }
    setIsLoading(false)
    return contracts
  }

  async function getProducts(){
    return await fetchBackendAsync("/products", defaultCatch(() => getProducts()));
  }

  async function saveContract(contract: ContractDTO){
    await deleteFromStorage("contracts")
    return await postBackendAsync("/contracts", contract, defaultCatch(() => saveContract(contract)));
  }

  async function saveProduct(contract: ContractDTO){
    return await postBackendAsync("/products", contract, defaultCatch(() => saveProduct(contract)));
  }

  async function searchComponentsByTag(tags: String){
    return await fetchBackendAsync(`/components?tags=${tags}`, defaultCatch(() => searchComponents(tags)));
  }

  async function searchComponents(query: String){
    return await fetchBackendAsync(`/components?q=${query}`, defaultCatch(() => searchComponents(query)));
  }

  async function deleteComponent(id: String){
    const confirmed = await confirmDelete("Willst du diese Komponente wirklich löschen?");
    if (!confirmed) {
      return;
    }
    return await deleteBackendAsync(`/components?id=${id}`, defaultCatch(() => deleteComponent(id)));
  }
  
  async function getAutoFills(){
    const data = localStorage.getItem("autofill")
    const date = localStorage.getItem("autofillDate")
    const now = new Date();
    const autofillDate = new Date(date);
    const isOlderThan24h = (now.getTime() - autofillDate.getTime()) > (24 * 60 * 60 * 1000);
    setIsLoading(true)
    // @ts-ignore
    if(!data || !date || isNaN(autofillDate) || isOlderThan24h){
      let comps = await searchComponents("")
      let lines = comps.components.map(comp=>comp.description).map(line=>line.split("\n")).flat()
      let autos = createAutoFills(lines)
      localStorage.setItem("autofill", JSON.stringify(autos))
      localStorage.setItem("autofillDate", new Date().toString())
      setIsLoading(false)
      return autos;
    }
    setIsLoading(false)
    return JSON.parse(data)
  }

  async function fetchCourseTypes(){
    return await fetchBackendAsync("/coursetypes", defaultCatch(() => fetchCourseTypes()));
  }

  async function pushCourseType(type: CourseTypeDTO){
    return await postBackendAsync("/coursetypes", type, defaultCatch(() => pushCourseType(type)));
  }

  async function deleteCourseType(type: CourseTypeDTO){
    const confirmed = await confirmDelete("Diesen Kurstyp wirklich löschen? Es sollten alle Kurse von diesen Typ storniert sein!");
    if (!confirmed) {
      return;
    }
    return await deleteBackendAsync("/coursetypes?id="+type.id, defaultCatch(() => deleteCourseType(type)));
  }

  async function fetchCoaches(){
    return await fetchBackendAsync("/coaches", defaultCatch(() => fetchCoaches()));
  }

  async function getEmailStrings(){
    return await fetchBackendAsync("/emailStrings", defaultCatch(() => getEmailStrings()));
  }

  async function saveEmailString(string: EmailStringDTO){
    return await postBackendAsync("/emailStrings", string, defaultCatch(() => saveEmailString(string)));
  }

  async function testEmailStrings(){
    return await fetchBackendAsync("/testEmailStrings", defaultCatch(() => testEmailStrings()));
  }

  async function fetchCalendarWeek(backend: string, startDate: Date, endDate: Date){
    setIsLoading(true)
    let ans = fetchBackendAsync(`${backend}/weeks/load?startDate=${startDate}&endDate=${endDate}`, defaultCatch(()=> fetchCalendarWeek(backend, startDate, endDate)))
    setIsLoading(false)
    return ans
  }

  async function dropIn(backend: string, dropInData: PersonDTO){
    setIsLoading(true)
    let ans = await postBackendAsync(`${backend}/dropin`, dropInData, defaultCatch(()=> dropIn(backend, dropInData)))
    setError({callback: undefined, error: "", header: "Deine Anfrage", text: ans.info})
    setIsLoading(false)
    return ans
  }

  async function fetchCrossfitWorkouts(token: string, date: Date, days: number): Promise<CrossfitComWorkoutDTO>{
    setIsLoading(true)
    let tmp = await postBackendAsync("/fetchWorkouts", {token, date, days}, defaultCatch(() => fetchCrossfitWorkouts(token, date, days)))
    setIsLoading(false)
    return tmp
  }

  async function translate(text: string): Promise<string>{
    setIsLoading(true)
    let tmp = await postBackendAsync("/translate", text, defaultCatch(() => translate(text)))
    setIsLoading(false)
    return tmp
  }

  return (<APIContext.Provider value={apiContext}>
    {children}
    <WarningModal/>
    <MyLoadingSpinner isLoading={isLoading} isUpdating={isUpdating}/>
    {error != null && (<Modal
      header={error.header}
      children={error.text}
      buttonP={error?.callback? "Try again": null}
      buttonS={"Schließen"}
      actionP={() => {
        setError(null);
        if(error.callback) error.callback();
      }}
      actionS={() => setError(null)}
      addon={error.error}
      valid={true}
    />)}
  </APIContext.Provider>);
}